import { ElementType, LayoutElement } from '../../../types/models/Elements';
import { panoramicLayouts3Photos } from '../panoramic/3photos';

export const mugLayouts3Photos: LayoutElement[][] = [
  ...panoramicLayouts3Photos,
];
